import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.canHide || (_ctx.canHide && _ctx.isInCart))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(!_ctx.isInCart ? _ctx.disableClass : _ctx.enableClass),
          type: "submit",
          disabled: !_ctx.isInCart,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedRemove && _ctx.clickedRemove(...args)))
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "bi bi-cart-dash-fill" }, null, -1)
        ]), 10, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}